export const piqStyles: string = `
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap');

:root {
  --containerWidth: 600px !important;
  --hosted-fields-border-color: #202122 !important;
  --hosted-fields-border-focus-color: #202122 !important;
  --hosted-fields-border-error-color: #202122 !important;
  --buttons-color: #facc00 !important;
  --border-color: #303036 !important;
  --headings-fontSize: 18px !important;
  --border-radius: 10px !important;
  --button-hover-color: #fff !important;
  --bghover-color: #333638 !important;
  --card-bg: #333638 !important;
  --dropdown-active-color: #202122 !important;
  --font-family: 'Open Sans', sans-serif !important;
}

#cashier .action-link {
  border: 1px solid #4a4a55;
  color: #b0b0ba !important;
  font-size: 12px;
  width: max-content;
  margin-top: 10px;
  padding: 12px 14px !important;
}

#cashier .action-link ion-icon {
  display: none;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 12px);
  padding: 6px 0;
  margin-left: unset !important;
  margin-bottom: unset !important;
}

.show-pending-transactions .header-container span:last-child {
  margin-right: 14px;
}

.show-pending-transactions .header-container span:not(:last-child) {
  margin-left: auto;
}

.btn {
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}

.btn.cashier-button {
  margin-top: 50px !important;
  color: #100e11 !important;
  font-weight: 800 !important;
  text-transform: uppercase;
}

#cashier {
  border-radius: 10px;
}

#cashier .all-transactions {
  background-color: #27272d !important;
  border-radius: 10px !important;
  margin: 12px 0 !important;
  border: 0 !important;
  padding: 12px 16px 12px 80px !important;
}

#cashier .all-transactions .amount {
  width: max-content !important;
  min-width: max-content !important;
  max-width: max-content;
  color: #fff !important;
  font-weight: 800 !important;
  font-size: 14px !important;
  margin-bottom: 4px;
}

#cashier .all-transactions .tx-type {
  display: flex !important;
  top: 50% !important;
  left: 16px !important;
  justify-content: center !important;
  align-items: center !important;
  width: 48px !important;
  height: 48px !important;
  border-radius: 12px !important;
  background: #323239 !important;
  transform: translateY(-50%);
}

#cashier .all-transactions .tx-type .ion {
  width: 24px;
  height: 24px;
  color: #b0b0ba;
}

#cashier .all-transactions > .flex > p:first-child::after {
  display: inline-block;
  padding: 0 2px;
  content: '—';
}

#cashier .all-transactions > .flex.space-between,
#cashier .all-transactions > .flex.space-between > p {
  display: inline-block !important;
}

#cashier .all-transactions p {
  margin: 2px 0;
  color: #79798b;
  font-weight: 600;
  font-size: 10px;
}

#cashier .time-range-options-container {
  margin-top: 14px;
  margin-bottom: 0;
}

#cashier .time-range-options-container .btn {
  padding: 3px 16px !important;
  color: #b0b0ba;
  font-weight: 700;
  font-size: 12px;
}

#cashier .time-range-options-container .btn.active {
  border-radius: 8px;
  color: var(--buttons-color);
  background: #44380d;
}

#cashier .time-range-options-container .btn.active, #cashier .time-range-options-container .btn:hover {
  background: #3e3e46;
}

.dropdown-container {
  background: transparent !important;
}

.dropdown-container .dropdown-toggler {
  border: 0 !important;
}

.dropdown-content {
  box-shadow: initial !important;
  -webkit-box-shadow: initial !important;
  top: 100% !important;
  background-color: #333638 !important;
}

.dropdown-icon {
  width: 22px;
  height: 22px;
  background-image: url('url(https://lvbet-static.com/images/svg/icon_chevron_down.svg)');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.dropdown-item {
  font-size: 80% !important;
}

.dropdown-toggler {
  border: 2px solid #313137 !important;
  background-color: transparent !important;
  font-size: 18px !important;
  line-height: 40px !important;
  font-weight: 600 !important;
}

.dropdown-toggler span {
  font-size: 18px !important;
  line-height: 40px !important;
  font-weight: 600 !important;
}

.ecopayz-custom-template {
  border-radius: 8px !important;
}

.input-wrapper .input-label-float {
  color: #777780 !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  letter-spacing: -0.05em !important;
}

.input-wrapper .input-label-float.active {
  margin: 0 !important;
}

.input-wrapper input {
  height: 64px !important;
  border: 0 !important;
  border-radius: 0 !important;
  border-bottom: 2px solid #313137 !important;
  background-color: transparent !important;
  font-size: 20px !important;
  line-height: 40px !important;
  font-weight: 700 !important;
  color: #fbcb00 !important;
}

.input-wrapper input:-webkit-autofill::first-line,
.input-wrapper input:-webkit-autofill,
.input-wrapper input:-webkit-autofill:hover,
.input-wrapper input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #1A1A1E inset !important;
  -webkit-text-fill-color: #facc00 !important;
  transition: background-color 5000s ease-in-out 0s;
}

.input-wrapper input:active,
.input-wrapper input:focus,
.input-wrapper .input-label-float.active ~ input {
  border-color: #facc00 !important;
}

.link {
  color: #fff !important;
  text-decoration: none !important;
}

.logo-container {
  width: 80px !important;
  height: 40px !important;
  background-color: #fff;
  padding: 3px;
  border-radius: 8px;
  order: -1;
}

.logo-container .logo-icon {
  margin: auto;
  max-width: 100% !important;
  max-height: 100% !important;
}

.notice-container .ion-icon-left {
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
}

.notice-container .notice-text {
  top: 0 !important;
}

.payment-method .payment-method-header .label-container {
  padding: 0 !important;
  margin-left: 20px !important;
}

.payment-method .payment-method-header:before {
  position: absolute !important;
  right: 25px;
  width: 25px !important;
  height: 25px !important;
  border: 2px solid #484851 !important;
  border-radius: 25px !important;
}

.payment-method-header {
  padding: 0 25px !important;
  border-radius: 10px;
}

.payment-method-label {
  margin: 0 !important;
}

.payment-method.active .payment-method-header:after {
  margin: 0 !important;
  top: calc(50% - 4.5px) !important;
  right: 32.5px;
  width: 10px !important;
  height: 10px !important;
  background-color: var(--cashierbackground-color) !important;
  transform: none !important;
}

.payment-method.active .payment-method-header:before {
  background-color: #facc00 !important;
  border-color: #facc00 !important;
}

.predefinedvalues {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
}

.predefinedvalues-btn {
  padding: 0 !important;
  max-width: unset !important;
  min-width: unset !important;
}

.predefinedvalues-btn button {
  background: transparent !important;
  border: 2px solid #313137 !important;
  border-radius: 10px !important;
  color: #fff !important;
  font-weight: 800 !important;
  font-size: 17px !important;
  line-height: 1 !important;
  padding: 12px !important;
}

.predefinedvalues-btn button.active,
.predefinedvalues-btn button:hover {
  background-color: #facc00 !important;
  color: #202122 !important;
}

.set-amount {
  display: flex;
  flex-direction: column;
}

.set-amount .input-container {
  order: -1;
  margin: 0 0 20px !important;
}

.show-pending-transactions {
  margin-top: 14px;
}

.show-pending-transactions .header-container {
  border: 0 !important;
}

.show-pending-transactions .header-container span {
  top: 0 !important;
  flex-grow: 0 !important;
  margin: 0 8px;
  padding: 10px 12px !important;
  border-radius: 12px;
  color: #b0b0ba !important;
  font-weight: 700;
  font-size: 12px !important;
  text-align: center !important;
  background: #323239;
}

.show-pending-transactions .header-container span.cancel-all-pending {
  border: 1px solid #4a4a55 !important;
  background: transparent !important;
}

.show-pending-transactions .transaction-details-container {
  margin-top: 24px !important;
}

.submit-button-container,
.submit-button-container .disabled-overlay {
  margin-top: 0 !important;
}

.transaction-overview {
  border: 0 !important;
}

.transaction-overview .label {
  color: #656565 !important;
  font-size: 14px !important;
  line-height: 150% !important;
}

.transaction-overview .label.value {
  color: #a2a6a9 !important;
}

.transactions .dropdown-container {
  --input-height: 58px;
}

.transactions .dropdown-toggler span {
  font-size: 16px !important;
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}

.v--modal.vue-dialog {
  background-color: var(--cashierbackground-color) !important;
}

.generic-inputs-container {
display: flex;
flex-direction: column;
gap: 12px;
}

.generic-inputs-container-multiple .inputs-wrapper:nth-child(n+3) {
margin-top: 0px;
}

.generic-inputs-container-multiple .inputs-wrapper{
width: 100% !important;
}

@media (min-width: 340px) {
  #cashier .action-link {
    position: absolute !important;
    top: 50%;
    left: 100%;
    margin: 0 !important;
    width: max-content;
    max-width: 160px;
    transform: translate(calc(-100% - 24px), -50%);
    width: 46px !important;
    height: 36px;
    font-size: 0;
    padding: 0 !important;
  }
  #cashier .action-link ion-icon {
    display: flex;
  }
}

@media (min-width: 480px) {
  #cashier .all-transactions .amount {
    position: absolute;
    top: 50%;
    left: calc(100% - 72px);
    margin: 0 !important;
    transform: translate(calc(-100% - 24px), -50%);
  }
}

@media (min-width: 580px) {
  #cashier .action-link {
    padding: 12px 24px !important;
    font-size: 12px !important;
    line-height: 100%;
    letter-spacing: -0.24px;
    width: max-content !important;
    height: unset;
  }
  #cashier .action-link ion-icon {
    display: none;
  }
  #cashier .all-transactions .amount {
    position: absolute;
    top: 50%;
    left: calc(100% - 184px);
    margin: 0 !important;
    transform: translate(calc(-100% - 24px), -50%);
  }
}
`;
